import { render, staticRenderFns } from "./ranked-nav.vue?vue&type=template&id=049e85d2&scoped=true&"
import script from "./ranked-nav.vue?vue&type=script&lang=js&"
export * from "./ranked-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049e85d2",
  null
  
)

export default component.exports